import FirebaseHandler from "../../firebase";
import { httpsCallable } from "firebase/functions";
export var magazineAccess = function magazineAccess(magazineNumber, magazineFile) {
    var magazineAccess = httpsCallable(FirebaseHandler.functions, "magazineAccess");
    return magazineAccess({
        magazineNumber: magazineNumber,
        magazineFile: magazineFile
    });
};
